// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"96e49d90","104":"c0279eb1","889":"02d74370","2998":"147f302f","3418":"147f302f","6251":"96e49d90","6544":"cb251121","7088":"87c50f20","8868":"c0279eb1","9828":"b946ad20"}[chunkId] + ".chunk.css";
};